import * as Config from "@/config";
import {useProgressStore} from "@/stores/progress";
import {useCustomerStore} from "@/stores/customer";
import {useUserStore} from "@/stores/user";
import {useGroupStore} from "@/stores/group";
import {useInformationStore} from "@/stores/information";
import {useDrmPfInformationListStore} from "@/stores/drmPfInformation";
import {useLayersStore} from "@/stores/layers";
import {useTicketDestinationsStore} from "@/stores/ticketDestinations";

interface BaseSortType {
  item_name: string;
  attribute_code?: string;
  column_name?: string;
  position_id?: number;
}

export type SortIndicatorProps = BaseSortType & {
  isCustomer?: boolean;
  isGroup?: boolean;
  isUser?: boolean;
  isInformation?: boolean;
  isDrmPfInformation?: boolean;
  isLayers?: boolean;
  isTicketDestinations?: boolean;
}

export type SortParams = BaseSortType & {
  order: number;
}

enum SortOrder {
  ASC = 1,
  DESC = 2
}

export const SortIndicator = (props: SortIndicatorProps) => {
  const [progressSortParams, setProgressSortParams, progressDoSort] = useProgressStore(state => [
    state.sortParams,
    state.setSortParams,
    state.doSort
  ]);
  const [customerSortParams, setCustomerSortParams, customerDoSort] = useCustomerStore(state => [
    state.sortParams,
    state.setSortParams,
    state.doSort
  ]);
  const [groupSortParams, setGroupSortParams, groupDoSort] = useGroupStore(state => [
    state.sortParams,
    state.setSortParams,
    state.doSort
  ]);
  const [userSortParams, setUserSortParams, userDoSort] = useUserStore(state => [
    state.sortParams,
    state.setSortParams,
    state.doSort
  ]);
  const [informationSortParams, setInformationSortParams, informationDoSort] = useInformationStore(state => [
    state.sortParams,
    state.setSortParams,
    state.doSort
  ]);
  const [drmPfInformationSortParams, setdrmPfInformationSortParams, drmPfInformationDoSort] = useDrmPfInformationListStore(state => [
    state.sortParams,
    state.setSortParams,
    state.doSort
  ]);
  const [layersSortParams, setLayersSortParams, layersDoSort] = useLayersStore(state => [
    state.sortParams,
    state.setSortParams,
    state.doSort
  ]);
  const [ticketDestinationsSortParams, setTicketDestinationsSortParams, ticketDestinationsDoSort] = useTicketDestinationsStore(state => [
    state.sortParams,
    state.setSortParams,
    state.doSort
  ]);

  let sortParams = progressSortParams;
  let setSortParams = setProgressSortParams;
  let doSort = progressDoSort;
  if (props.isCustomer) {
    sortParams = customerSortParams;
    setSortParams = setCustomerSortParams;
    doSort = customerDoSort;
  } else if (props.isGroup) {
    sortParams = groupSortParams;
    setSortParams = setGroupSortParams;
    doSort = groupDoSort;
  } else if (props.isUser) {
    sortParams = userSortParams;
    setSortParams = setUserSortParams;
    doSort = userDoSort;
  } else if (props.isInformation) {
    sortParams = informationSortParams;
    setSortParams = setInformationSortParams;
    doSort = informationDoSort;
  } else if (props.isDrmPfInformation) {
    sortParams = drmPfInformationSortParams;
    setSortParams = setdrmPfInformationSortParams;
    doSort = drmPfInformationDoSort;
  } else if (props.isLayers) {
    sortParams = layersSortParams;
    setSortParams = setLayersSortParams;
    doSort = layersDoSort;
  } else if (props.isTicketDestinations) {
    sortParams = ticketDestinationsSortParams;
    setSortParams = setTicketDestinationsSortParams;
    doSort = ticketDestinationsDoSort;
  }

  const isActive = (order: number) => {
    const bool = props.item_name === sortParams.item_name
      && props.attribute_code == sortParams.attribute_code
      && props.column_name == sortParams.column_name
      && props.position_id == sortParams.position_id
      && sortParams.order == order;
    return bool ? 'active' : '';
  };

  const onClickSort = (order: SortOrder) => {
    setSortParams({...props, order});
    doSort({...props, order});
  }

  return (
    <div className="sort-indicator">
      <button className={`arrow-btn arrow-up ${isActive(SortOrder.ASC)}`}
              onClick={() => onClickSort(SortOrder.ASC)}
              aria-label="昇順ソート"></button>
      <button className={`arrow-btn arrow-down ${isActive(SortOrder.DESC)}`}
              onClick={() => onClickSort(SortOrder.DESC)}
              aria-label="降順ソート"></button>
    </div>
  )
}